export * from '@taqueria/protocol/out/types/Alias';
